/**
 * referral-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Refer Subject
    </h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (submit)="submit()">
      <div class="form-group">
        <label>
          Enter a note or brief description for the receiving organization:
        </label>
        <textarea
          autosize
          [minimum]="54"
          class="form-control"
          [formControl]="note">
        </textarea>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="submit()">
      Submit
    </button>
  </div>
  `,
  styles: [
    "/deep/ prettyjson pre {outline: none !important;}",
    "/deep/ #sendButton {position: relative; top: -8px;}"
  ]
})
export class ReferralModalComponent
  implements ModalComponent<BSModalContext>, OnInit
{
  public note : FormControl;
  public form : FormGroup;

  constructor (
    public dialog : DialogRef<BSModalContext>
  ) {}

  public ngOnInit () : void
  {
    this.note = new FormControl("", Validators.required);
    this.form = new FormGroup({note: this.note});
  }

  public submit () : void
  {
    if (!this.note.valid)
    {
      console.error("Validation error:", this.note.errors);
      return;
    }
    this.dialog.close(this.note.value);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/referral-modal.component.ts